export default {
  defaultSectionTitle: 'Form Section',
  checkFormErrors: 'Please check errors in the form',
  validation: {
    requiredSelect: 'Please select {field}',
    requiredInput: 'Please enter {field}',
    requiredUpload: 'Please upload {field}',
    numberMin: '{label} cannot be less than {limit}',
    numberMax: '{label} cannot be greater than {limit}',
    invalidFormat: 'Invalid format',
    fallback: 'Validation failed'
  },
  upload: {
    dragMain: 'Click or drag files here to upload',
    dragSub: 'Please upload related files',
    uploadFailed: 'File upload failed'
  },
  apiDynamic: {
    loading: 'Loading options...',
    empty: 'No options available',
    loadFailed: 'Failed to load options',
    missingUrl: 'Request URL is not configured',
    retry: 'Retry'
  },
  placeholders: {
    containerSelect: 'Select container type and quantity',
    date: 'Select date',
    containerDetail: 'Click to select container/cargo details',
    searchSelect: 'Search and select {field}',
    customer: 'Select customer',
    vesselName: 'Enter vessel name',
    voyageNo: 'Enter voyage number',
    multiLine: 'Please enter'
  },
  recognition: {
    confidence: 'Recognition confidence: {percent}%',
    confirmHint: 'Please confirm'
  },
  modals: {
    customer: {
      title: 'Select Customer',
      searchPlaceholder: 'Search by name, contact, or phone',
      empty: 'No matching customers found'
    },
    container: {
      title: 'Select Container Type & Quantity',
      clearAll: 'Clear All',
      quickFill: 'Quick Fill'
    }
  },
  containerSelect: {
    title: 'Select Container Type & Qty',
    placeholder: 'Select container type and quantity',
    clear: 'Clear',
    quickFill: 'Quick fill'
  },
  customerSelect: {
    title: 'Select Customer',
    placeholder: 'Select customer',
    searchPlaceholder: 'Search by name, contact, or phone',
    empty: 'No matching customers found',
    loadFailed: 'Failed to load customer list',
    retry: 'Retry'
  },
  vesselVoyage: {
    vesselPlaceholder: 'Enter vessel name',
    voyagePlaceholder: 'Enter voyage no.'
  },
  multiLine: {
    placeholder: 'Please enter',
    lineChars: 'L{line}: {count} chars'
  },
  field: {
    confidenceTooltip: 'Recognition confidence: {percent}%',
    confirmHint: 'Please confirm',
    inputLabel: 'Enter {label}',
    selectLabel: 'Select {label}',
    selectContainer: 'Select container type and quantity',
    selectDate: 'Select date',
    selectStartDate: 'Start time',
    selectEndDate: 'End time',
    selectCustomer: 'Select customer',
    cargoPlaceholder: 'Click to select containers or cargo details',
    consigneePlaceholder: 'Search and select {label}',
    uploadTip: 'PDF/JPG/PNG/DOC supported, up to 10 files',
    uploadMainText: 'Click or drag files here to upload',
    uploadHint: 'Please upload related files',
    uploadFailed: 'File upload failed',
    uploadRequired: 'Please upload {label}',
    invalidFormat: 'Invalid format'
  },
  validate: {
    validationFailed: 'Validation failed'
  },
  renderer: {
    attachments: 'Attachments',
    sectionDefault: 'Form section',
    showJson: 'View JSON',
    hideJson: 'Hide JSON',
    jsonPreviewTitle: 'businessFields preview',
    copyJson: 'Copy JSON',
    jsonCopied: 'JSON copied',
    validateFailed: 'Please check form errors',
    requiredField: 'Enter {label}',
    addRow: 'Add row',
    removeRow: 'Remove row',
    action: 'Actions',
    delete: 'Delete',
    noFields: 'No fields',
    serviceTypeConfigEmpty: 'Configure a Service Type radio and its options in the top area first',
    cargoInfoWithType: '{type} cargo info',
    addRowWithType: 'Add {type} row',
    serviceTypeFcl: 'FCL',
    serviceTypeLcl: 'LCL',
    serviceTypeRoro: 'RORO',
    serviceTypeBulk: 'Bulk',
    serviceTypeDefault: 'Default',
    sourceTag: 'Source'
  },
  cargoSummary: {
    match: {
      singleType: 'single type',
      pieces: 'pieces',
      perContainer: 'per container',
      perPallet: 'per pallet',
      totalPieces: 'total pieces',
      totalWeight: 'total gross weight',
      totalVolume: 'total volume',
      volume: 'volume',
      oversized: 'oversized',
      stowageFactor: 'stowage factor',
      defaultCm: 'default CM',
      defaultUnitCm: 'default unit:CM',
      defaultUnitCmFw: 'default unit: CM',
      defaultM: 'default M',
      defaultUnitM: 'default unit:M',
      defaultUnitMFw: 'default unit: M'
    }
  },
  viewTemplate: {
    invalidTitle: 'Invalid template data',
    invalidSubtitle: 'View template data is missing or malformed.',
    notConfiguredTitle: 'Template not configured',
    notConfiguredSubtitle: 'This view template has no sections.',
    defaultTitle: 'Order details',
    noData: 'No matching data'
  },
  viewField: {
    noImage: 'No image'
  },
  feeDetail: {
    addRow: 'Add Fee Row',
    itemCount: '{count} item(s)',
    selectContainerFirst: 'Please select container types first',
    clientReadonlyHint: 'Fee details are view-only. Please contact your forwarder if needed.',
    emptyHint: 'No fee details. Click [Add Fee Row] to add',
    columns: {
      feeName: 'Fee Name',
      basis: 'Billing Unit',
      currency: 'Currency',
      unitPriceContainer: 'Unit Price (Container)',
      unitPriceTicket: 'Unit Price (Ticket)',
      remarks: 'Remarks',
      perTicket: 'Per Ticket',
      selectContainerType: 'Select container type',
      byContainer: 'By Container',
      byTicket: 'By Ticket'
    },
    placeholders: {
      feeName: 'Fee Name',
      remarks: 'Remarks'
    },
    actions: {
      restoreSource: 'Restore source value',
      deleteRow: 'Delete this row'
    }
  },
  vesselSchedule: {
    title: 'Select Vessel Schedule (Optional)',
    hint: 'The following schedules are supported by the rate. Selected schedule will autofill Vessel/Voyage, ETD and ETA. You may also skip to retain current values.',
    transit: 'Transit',
    days: 'days',
    selected: 'Selected',
    skipTitle: 'Skip schedule selection',
    skipSub: 'Retain current vessel / voyage / schedule',
    empty: 'No available schedules',
    cancel: 'Cancel',
    skip: 'Skip and place order'
  },
  containerQty: {
    placeholder: 'Select container types and quantities',
    emptyPrompt: 'No available container types, please select rate source first',
    unit: 'ctnr'
  }
}
